import React, {useState} from 'react';
import DeleteDialog from '@pluto/delete-dialog/DeleteDialog';
import DeleteIcon from '@material-ui/icons/Delete';
import wrap from 'wraptile';

export interface QCReportsNotesDeleteProps {
    onDeleteClick: () => void;
}

export type SetIsOpenDeleteDialogType = (value: boolean) => void

export const handleConfirm = wrap((onDeleteClick: () => void, setIsOpenDeleteDialog: SetIsOpenDeleteDialogType) => {
    onDeleteClick();
    setIsOpenDeleteDialog(false);
});

export const onOpenDeleteDialog = wrap((setIsOpenDeleteDialog: SetIsOpenDeleteDialogType) => {
    setIsOpenDeleteDialog(true);
});

export const onCloseDeleteDialog = wrap((setIsOpenDeleteDialog: SetIsOpenDeleteDialogType) => {
    setIsOpenDeleteDialog(false);
});

export const getDeleteDialog = (setIsOpenDeleteDialog: SetIsOpenDeleteDialogType, isOpenDeleteDialog: boolean, onDeleteClick: () => void) => {
    if (isOpenDeleteDialog)
        return (
            <DeleteDialog
                text="Are you sure you want to delete the note?"
                onClose={onCloseDeleteDialog(setIsOpenDeleteDialog)}
                onConfirm={handleConfirm(onDeleteClick, setIsOpenDeleteDialog)}
            />
        );
};

export const QCReportsNotesDelete = (props: QCReportsNotesDeleteProps) => {
    const {onDeleteClick} = props;
    const [isOpenDeleteDialog, setIsOpenDeleteDialog] = useState<boolean>(false);
    
    return (
        <>
            <DeleteIcon onClick={onOpenDeleteDialog(setIsOpenDeleteDialog)} />
            {getDeleteDialog(setIsOpenDeleteDialog, isOpenDeleteDialog, onDeleteClick)}
        </>
    );
};
